export const CROATIAN = "hr";

export const ENGLISH = "en";
